<template>
    <table style="padding: 10px 20px; margin: 20px 0; background: rgba(255,255,255,.6); border-radius: 10px; box-shadow: 0 0 10px rgba(0,0,0,.1); text-align: left; width: 100%; line-height: 26px;" cellpadding="0" cellspacing="0" border="0">
        <tr style="font-size: 12px">
            <td style="padding-left: 0; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">
                FEATURES
            </td>
            <td style="width: 70px; font-weight: 600; text-align: center; text-shadow: 0.5px 0.5px 0 #000;">
                BASIC
            </td>
            <td style="width: 70px; font-weight: 600; text-align: center; text-shadow: 0.5px 0.5px 0 #000;">
                PREMIUM
            </td>
        </tr>
        
        <tr>
            <td style="padding-left: 0; text-align: left;">
                Photos
            </td>
            <td style="text-align: center; font-weight: 600; font-size: 20px; color: #888;">
                -
            </td>
            <td style="text-align: center; color: green;">
                <mdi style="color: green;">mdiCheck</mdi>
            </td>
        </tr>
        <tr>
            <td style="padding-left: 0; text-align: left;">
                Videos
            </td>
            <td style="text-align: center; font-weight: 600; font-size: 20px; color: #888;">
                -
            </td>
            <td style="text-align: center; color: green;">
                <mdi style="color: green;">mdiCheck</mdi>
            </td>
        </tr>
        <tr>
            <td style="padding-left: 0; text-align: left;">
                Calculator
            </td>
            <td style="text-align: center; color: green;">
                <mdi style="color: green;">mdiCheck</mdi>
            </td>
            <td style="text-align: center; color: green;">
                <mdi style="color: green;">mdiCheck</mdi>
            </td>
        </tr>
        
        <tr>
            <td style="padding-left: 0; text-align: left;">
                SMART plan tool
            </td>
            <td style="text-align: center; font-weight: 600; font-size: 20px; color: #888;">
                -
            </td>
            <td style="text-align: center; color: green;">
                <mdi style="color: green;">mdiCheck</mdi>
            </td>
        </tr>



        <!-- <tr style="font-size: 12px">
            <td style="padding-left: 0; padding-top: 14px; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">
                EXTRA FEATURES
            </td>
            <td style="width: 70px; padding-top: 14px; font-weight: 600; text-align: center; text-shadow: 0.5px 0.5px 0 #000;">
                BASIC
            </td>
            <td style="width: 70px; padding-top: 14px; font-weight: 600; text-align: center; text-shadow: 0.5px 0.5px 0 #000;">
                PREMIUM
            </td>
        </tr> -->


        <!-- <tr>
            <td style="padding-left: 0; text-align: left;">
                Continuous updates
            </td>
            <td style="text-align: center; color: green;">
                <mdi style="color: green;">mdiCheck</mdi>
            </td>
            <td style="text-align: center; color: green;">
                <mdi style="color: green;">mdiCheck</mdi>
            </td>
        </tr> -->
        <!-- <tr>
            <td style="padding-left: 0; text-align: left;">
                Save plan / History
            </td>
            <td style="text-align: center; font-weight: 600; font-size: 20px; color: #888;">
                -
            </td>
            <td style="text-align: center; color: green;">
                <mdi style="color: green;">mdiCheck</mdi>
            </td>
        </tr> -->
        <!-- <tr>
            <td style="padding-left: 0; text-align: left;">
                Export to PDF
            </td>
            <td style="text-align: center; color: green;">
                -
            </td>
            <td style="text-align: center; color: green;">
                <mdi style="color: green;">mdiCheck</mdi>
            </td>
        </tr> -->
        <!-- <tr>
            <td style="padding-left: 0; text-align: left;">
                Send in email
            </td>
            <td style="text-align: center; font-weight: 600; font-size: 20px; color: #888;">
                -
            </td>
            <td style="text-align: center; color: green;">
                <mdi style="color: green;">mdiCheck</mdi>
            </td>
        </tr> -->
    </table>
</template>

<style>

</style>

<script>
export default {

}
</script>
